import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IDuplicateArchivePlanState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const DuplicateArchivePlanEmptyState: IDuplicateArchivePlanState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
